"use strict";
import { useMemo } from "react";
import { FeatureFlags, getFeatureFlagName } from "features/gating/flags";
import {
  getStatsigClient
} from "features/gating/sdk/statsig";
import { logger } from "utilities/src/logger/logger";
const TOPAZ_FLAG_OVERRIDES = {
  // Topaz has no V4 hook pools — keep the swap-settings "V4 hooks" toggle off.
  [FeatureFlags.SwapSettingsV4HooksToggle]: false
};
export function useFeatureFlag(flag) {
  return TOPAZ_FLAG_OVERRIDES[flag] ?? true;
}
export function useFeatureFlagWithLoading(flag) {
  return { value: TOPAZ_FLAG_OVERRIDES[flag] ?? true, isLoading: false };
}
export function getFeatureFlag(flag) {
  try {
    const name = getFeatureFlagName(flag);
    return getStatsigClient().checkGate(name);
  } catch (e) {
    logger.debug("gating/hooks.ts", "getFeatureFlag", JSON.stringify({ e }));
    return false;
  }
}
export function useFeatureFlagWithExposureLoggingDisabled(flag) {
  return TOPAZ_FLAG_OVERRIDES[flag] ?? true;
}
export function getFeatureFlagWithExposureLoggingDisabled(flag) {
  const name = getFeatureFlagName(flag);
  return getStatsigClient().checkGate(name, { disableExposureLog: true });
}
export function useExperimentGroupNameWithLoading(_experiment) {
  return { value: null, isLoading: false };
}
export function useExperimentGroupName(_experiment) {
  return null;
}
export function useExperimentValue(_experiment, _param, defaultValue, _customTypeGuard) {
  return defaultValue;
}
export function getExperimentValue(experiment, param, defaultValue, customTypeGuard) {
  const statsigExperiment = getStatsigClient().getExperiment(experiment);
  const value = statsigExperiment.get(param, defaultValue);
  return checkTypeGuard(value, defaultValue, customTypeGuard);
}
export function useExperimentValueWithExposureLoggingDisabled(_experiment, _param, defaultValue, _customTypeGuard) {
  return defaultValue;
}
export function useDynamicConfigValue(_config, _key, defaultValue, _customTypeGuard) {
  return defaultValue;
}
export function getDynamicConfigValue(config, key, defaultValue, customTypeGuard) {
  const dynamicConfig = getStatsigClient().getDynamicConfig(config);
  const value = dynamicConfig.get(key, defaultValue);
  return checkTypeGuard(value, defaultValue, customTypeGuard);
}
export function getExperimentValueFromLayer(layerName, param, defaultValue, customTypeGuard) {
  const layer = getStatsigClient().getLayer(layerName);
  const value = layer.get(param, defaultValue);
  return checkTypeGuard(value, defaultValue, customTypeGuard);
}
export function useExperimentValueFromLayer(_layerName, _param, defaultValue, _customTypeGuard) {
  return defaultValue;
}
export function checkTypeGuard(value, defaultValue, customTypeGuard) {
  const isOfDefaultValueType = (val) => typeof val === typeof defaultValue;
  if (customTypeGuard?.(value) || isOfDefaultValueType(value)) {
    return value;
  } else {
    return defaultValue;
  }
}
export function useStatsigClientStatus() {
  return useMemo(
    () => ({
      isStatsigLoading: false,
      isStatsigReady: true,
      isStatsigUninitialized: false
    }),
    []
  );
}
